// Foaia care urcă de la marginea de jos.
//
// Pe telefon ea ţine locul ferestrei modale, şi nu din modă: degetul stă jos, iar o
// fereastră centrată cere să întinzi mâna până la mijlocul ecranului ca s-o închizi.
// Foaia se închide cu o mişcare scurtă în jos, exact acolo unde degetul e deja.
//
// Se trage doar de partea de sus — mânerul şi antetul. Dacă s-ar trage de oriunde,
// n-ai mai putea derula o listă lungă înăuntru fără s-o închizi din greşeală.

import { el } from '../core/util.js';
import { icon } from './icons.js';

/** Sub atâţia pixeli traşi în jos, foaia se aşază la loc în loc să se închidă. */
const PRAG = 90;

export function foaie({ titlu = '', corp, actiuni = [], inalta = false, laInchidere } = {}) {
  const maner = el('div', { class: 'sh-maner' }, [el('span')]);
  const panou = el('section', { class: `sh-panou${inalta ? ' inalta' : ''}` });
  const fundal = el('div', { class: 'sh-fundal' }, [panou]);

  const antet = titlu
    ? el('header', { class: 'sh-cap' }, [
      el('h3', { class: 'sh-titlu', text: titlu }),
      el('button', { class: 'sh-x', title: 'Закрыть', onclick: () => inchide() }, [icon('close', 14)]),
    ])
    : null;

  // `.filter(Boolean)`, fiindca `Node.append(null)` insereaza textul „null" — spre
  // deosebire de `el()`, care sare peste. Fara el, o foaie fara titlu si fara butoane
  // aparea cu doua „null" scrise in ea.
  panou.append(...[
    maner,
    antet,
    el('div', { class: 'sh-corp' }, [corp]),
    actiuni.length
      ? el('div', { class: 'sh-actiuni' }, actiuni.map((a) => el('button', {
        class: `btn${a.primary ? ' primary' : ''}`, text: a.label,
        onclick: () => a.onClick?.(inchide),
      })))
      : null,
  ].filter(Boolean));

  let inchisa = false;
  const inchide = () => {
    if (inchisa) return;
    inchisa = true;
    panou.style.transform = 'translateY(100%)';
    fundal.style.opacity = '0';
    window.removeEventListener('keydown', laTasta);
    setTimeout(() => { fundal.remove(); laInchidere?.(); }, 220);
  };
  const laTasta = (e) => { if (e.key === 'Escape') inchide(); };

  // Se inchide doar daca si apasarea, si ridicarea au cazut pe fundal.
  //
  // Cu un `click` simplu, gestul care deschide foaia o si inchidea: degetul apasa pe
  // buton, foaia apare sub el, iar ridicarea ajunge pe fundalul proaspat apparut si
  // trece drept „apasare in afara". Cerem ambele capete ale gestului pe fundal.
  let dinFundal = false;
  fundal.addEventListener('pointerdown', (e) => { dinFundal = e.target === fundal; });
  fundal.addEventListener('click', (e) => { if (dinFundal && e.target === fundal) inchide(); });
  window.addEventListener('keydown', laTasta);

  // --- tragerea în jos ---
  let pornit = null;
  const zonaDeTras = [maner, antet].filter(Boolean);
  for (const z of zonaDeTras) {
    z.addEventListener('touchstart', (e) => {
      pornit = e.touches[0].clientY;
      panou.style.transition = 'none';
    }, { passive: true });
  }
  panou.addEventListener('touchmove', (e) => {
    if (pornit === null) return;
    const dy = e.touches[0].clientY - pornit;
    if (dy > 0) panou.style.transform = `translateY(${dy}px)`;
  }, { passive: true });
  panou.addEventListener('touchend', (e) => {
    if (pornit === null) return;
    const dy = (e.changedTouches[0]?.clientY ?? pornit) - pornit;
    pornit = null;
    panou.style.transition = '';
    if (dy > PRAG) inchide();
    else panou.style.transform = '';
  });

  document.body.append(fundal);
  // Citirea asta forteaza browserul sa aseze foaia in starea de pornire inainte de a-i
  // schimba clasa; fara ea, cele doua schimbari se contopesc si nu se vede nicio miscare.
  //
  // Prima varianta astepta un cadru cu `requestAnimationFrame`. E tiparul obisnuit si e
  // gresit aici: cadrele nu se deseneaza in file de fundal si sunt limitate cand
  // bateria e pe sfarsite, iar atunci clasa nu se mai punea deloc — foaia ramanea sub
  // marginea de jos, adica un buton care nu face nimic. Un reflow se intampla mereu.
  void fundal.offsetHeight;                          // eslint-disable-line no-void
  fundal.classList.add('deschisa');

  return { fundal, panou, inchide };
}
